import { Children, isValidElement } from "react";

/** The value types `FaroSelect` supports - the same constraint flat-ui's dropdown family takes. */

/**
 * @returns the rendered content of the child among `children` whose own `value` prop matches, or
 *   `undefined` if none does - the fallback `FaroSelect` uses when no `renderValue` is supplied,
 *   replicating what MUI's native `Select` did automatically by scanning its `MenuItem` children.
 * @param children the raw children passed to `FaroSelect`
 * @param value the current value to match against
 */
export function findMatchingChildLabel(children, value) {
  if (value === undefined) {
    return undefined;
  }
  for (const child of Children.toArray(children)) {
    if (isValidElement(child) && child.props.value === value) {
      return child.props.children;
    }
  }
  return undefined;
}